export class VispApp {
    name:string;
    title:string;
    subtitle?:string;
    icon?:string;
    saveInProgress?:boolean;
    deleteInProgress?:boolean;
    disabled:boolean = false;
}